<template lang="pug">
  #dashboard.dashboard-main.md-scrollbar.md-theme-default
    transition(name="fade")
      .md-layout.md-gutter(v-show="ready")
        component(
          v-if="accessDashboards && Object.keys(accessDashboards).length"
          v-for="(dashboard, index) in accessDashboards"
          v-bind:is="dashboard"
          v-bind:key="index"
        )

        .dashboard-card.md-layout-item.md-size-100
          md-card#version-changes
            md-card-header
              div(class="md-title") Последние изменения в стистеме
            md-card-content(v-html="versionChanges") {{versionChanges}}
</template>
<script>
  export default {
    data() {
      return {
        versionChanges: '',
        ready: false,
      }
    },
    computed: {
      access() {
        return this.$store.state.module.accessModules;
      },
      dashboards() {
        return this.$root.dashboards;
      },
      accessDashboards() {
        let result = {};
        if (!this.dashboards || !this.access || !Object.keys(!this.access)) return result;
        Object.keys(this.dashboards).map(key => {
            let item = this.dashboards[key];
            if ( this.access[item.module] ) result[key] = item;
        });
        return result;
      }
    },
    methods: {
      getVersionChanges() {
        return this.$store.dispatch('getVersionChanges').then(r => {
          this.versionChanges = r;
          return r;
        });
      }
    },
    created() {
      this.$store.commit('setTitle', 'Dashboard');
      this.getVersionChanges().then(() => {
        setTimeout(() => {this.ready = true;}, 500);
      });
      
      this.$root.isAuth().then(user => {
        if (user && user.id) {
          let isStoreKeeper = user.groups.find(item => item.code === "storekeepers");
          if (isStoreKeeper) this.$router.push({ name: 'StorekeepersFreights' });
          else this.$router.push({ name: 'Index' });
        }
      });
    },
  }
</script>
<style lang="sass">
  #dashboard
    .dashboard-card
      margin: 15px 0 50px 0
      padding: 0px !important
      .md-card
        background-color: #fff
        .md-card-content
          background-color: #fff
    #version-changes
      max-height: 400px
      .version-changes-page
        border: 0px
        background: transparent
        width: 100%
        max-height: 500px
</style>



// WEBPACK FOOTER //
// Index.vue?1ddffffe